import type { Tenant } from 'types/shopConfig'

import ATRefinedQueries from './RefinedSearchSuggestionsByTenant/AT'
import COMRefinedQueries from './RefinedSearchSuggestionsByTenant/COM'
import FRRefinedQueries from './RefinedSearchSuggestionsByTenant/FR'
import ITRefinedQueries from './RefinedSearchSuggestionsByTenant/IT'

export const getRefinedQueriesByTenant = (tenant: Tenant) => {
  switch (tenant) {
    case 'com':
      return COMRefinedQueries
    case 'at':
      return ATRefinedQueries

    case 'it':
      return ITRefinedQueries

    case 'fr':
      return FRRefinedQueries
    default:
      return null
  }
}
